// bao migrate skip
import * as ko from "knockout";
import { IUniversalField } from "../../interfaces/iuniversal-field";

class RadioButtonsViewModel {
    TagViewModel: IUniversalField = null;
    TagId: string = null;
    Parent: any = null;
    CboOptions = ko.observableArray<string>([]);
    TagTextValue;
    SelectedOption;
    constructor(shiftReportTagTab, tagId) {
        this.Parent = shiftReportTagTab;
        this.TagId = tagId;
        this.TagViewModel = this.Parent.getTagModel(this.TagId);
        this.CboOptions(this.TagViewModel.Options);
        this.TagTextValue = this.Parent.getTagObservable(this.TagId).TextValue;
        this.SelectedOption = ko.pureComputed({
            read: () => {
                return [ko.unwrap(this.TagTextValue)];
            },
            write: (val) => {
                if (val) {
                    this.TagTextValue(val[0]);
                }
            }
        });
    }
    init() {
        if (!ko.unwrap(this.TagTextValue) && this.CboOptions()) {
            this.Parent.pauseDirtyFlag();
            this.SelectedOption([this.CboOptions()[0]]);
            this.Parent.resumeDirtyFlag();
        }
    }
}
export default RadioButtonsViewModel;